export default __webpack_public_path__ + "static/media/Strap CT Correct.e4add64c.png";